<div 
    class="message-box"
    (click)="closeNotification()"
    [innerHtml]="message">
</div>
